import React from "react";

export default function More({ profile }) {
  return (
    <div className="profile_card">
      <div className="profile_card_header">
        More
      </div>
      
      <div className="more_content">
        <div className="more_section">
          <div className="more_section_header">
            <i className="likes_icon"></i>
            Likes
          </div>
          <div className="more_section_content">
            <div style={{ 
              textAlign: "center", 
              padding: "20px", 
              color: "#65676b",
              fontSize: "14px"
            }}>
              No likes to show
            </div>
          </div>
        </div>

        <div className="more_section">
          <div className="more_section_header">
            <i className="sports_icon"></i>
            Sports
          </div>
          <div className="more_section_content">
            <div style={{ 
              textAlign: "center", 
              padding: "20px", 
              color: "#65676b",
              fontSize: "14px"
            }}>
              No sports to show
            </div>
          </div>
        </div>

        <div className="more_section">
          <div className="more_section_header">
            <i className="music_icon"></i>
            Music
          </div>
          <div className="more_section_content">
            <div style={{ 
              textAlign: "center", 
              padding: "20px", 
              color: "#65676b",
              fontSize: "14px"
            }}>
              No music to show
            </div>
          </div>
        </div>

        <div className="more_section">
          <div className="more_section_header">
            <i className="movies_icon"></i>
            Movies
          </div>
          <div className="more_section_content">
            <div style={{ 
              textAlign: "center", 
              padding: "20px", 
              color: "#65676b",
              fontSize: "14px"
            }}>
              No movies to show
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 